var render = function render(){var _vm=this,_c=_vm._self._c;return _c('graph-detail06-template',{attrs:{"com-group-list":_vm.comGroupList,"board-ids":[107],"field-code":"facility-public","graph1-title":"전체 (공중(다중)이용시설)안전·보건 교육 현황","graph2-title":"월별 (공중(다중)이용시설)안전·보건 교육 현황","graph3-title":"기간별 (공중(다중)이용시설)안전·보건 교육 현황"}})
}
var staticRenderFns = []

export { render, staticRenderFns }